import axios from 'axios'
import router from '../router/index.js'
import store from '../store'
import { statusCode } from '../common/js/utils'
import { homeApp } from '../config/index'
import { MessageBox } from 'element-ui'

const calendarBaseUrl = homeApp.calendarUrl // 正式环境

const consoleBaseUrl = `${homeApp.baseUrl}` //  测试环境
axios.defaults.timeout = 80000 //    响应时间

axios.defaults.headers = {
  'Accept': 'application/json;charset=utf-8',
  'Content-Type': 'application/json;charset=utf-8'
}
// axios.defaults.baseURL = 'http://localhost:3000' //  配置本机模拟数据接口地址
// axios.defaults.baseURL = 'http://10.8.51.237:8086' //  配置本地测试接口地址
axios.defaults.baseURL = `${homeApp.baseUrl}` //  配置现网测试环境接口地址

axios.interceptors.request.use(
  config => {
    // 在发送请求之前做某件事
    if (
      config.method === 'post'
    ) {
      // 序列化
      config.data = JSON.stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 在响应请求之后做某件事
axios.interceptors.response.use(
  res => {
    if (res.data.status === statusCode.TIME_OUT) { // 登录过期，清理用户信息，路由跳转
      store.dispatch('clearUserInfo') // 清空用户账户信息数据
      store.dispatch('clearShopping') // 清空用户购物车数据
      store.commit('SHOW_LOGIN', true) // 显示登录弹框
    }
    return res.data
  },
  error => {
    return Promise.reject(error)
  }
)
// 返回一个Promise(发送get请求)
export function fetch (url, params = {}) {
  return axios.get(url, {params: params})
}
// 返回一个Promise(发送post请求)
export function post (url, params) {
  return axios.post(url, params)
}

// 返回一个Promise(delete请求)
export function remove (url, params) {
  return axios.delete(url, params)
}

export default {
  // 登录
  login (params) {
    return post('/apppublic/user/login', params)
  },
  // 登出
  loginout () {
    return fetch('/apppublic/user/logout')
  },
  // 获取个人信息头像
  getpersonalinfo () {
    return fetch('/apppublic/user/info')
  },
  // 注册
  register (params) {
    return post('/apppublic/user/register', params)
  },
  // 查询轮播图页面url
  swiperurl (sceneId) {
    return fetch(`/apppublic/banner/scence/${sceneId}`)
  },
  // 首页不同目录类
  catalogs (sceneId) {
    return fetch(`/apppublic/catalogs/scence/${sceneId}`)
  },
  // 商品列表获取
  shopcatalogs (catalogId, pnum, psize) {
    return fetch(`/apppublic/catalogs/${catalogId}/wares?pnum=${pnum}&psize=${psize}`)
  },
  // 商品详情页面
  shopcatalogsdetail (wareId, waretypeId) {
    return fetch(`/apppublic/wares/${wareId}/waretype/${waretypeId}/description`)
  },
  // 商品详情里面的产品包
  shopBall (comboid, pnum, psize) {
    return fetch(`/apppublic/products/combo/${comboid}/products?pnum=${pnum}&psize=${psize}`)
  },
  // 常用搜索词
  searchtext (sceneId) {
    return fetch(`/apppublic/lables/scence/${sceneId}`)
  },
  // 首页搜索
  search (lablename, pnum, psize) {
    return fetch(`/apppublic/lables/waresearch?lablename=${lablename}&pnum=${pnum}&psize=${psize}`)
  },
  // 获取验证码图片
  vcodepic () {
    return fetch(`/apppublic/vcode/gifcode`)
  },
  // 获取普通验证码
  sendcode (type, phone) {
    return fetch(`/apppublic/vcode/sms?type=${type}&phone=${phone}`)
  },
  // 找回密码
  retrievepassword (params) {
    return post('/apppublic/user/retrievepassword', params)
  },
  // 保存购物车
  saveshopcart (params) {
    return post('/apppublic/cart/save', params)
  },
  // 单条保存购物车接口
  singlesavecart (params) {
    return post('/apppublic/cart/singlesave', params)
  },
  // 删除购物车接口
  deleteshopcart (params) {
    return post('/apppublic/cart/deletecommodity', params)
  },
  // 查询购物车数量
  getshopcarnumber () {
    return fetch('/apppublic/cart/count')
  },
  // 查询购物车
  queryshopcart () {
    return fetch('/apppublic/cart/get')
  },
  // 生成订单
  createorder (params) {
    return post('/apppublic/order/save', params)
  },
  // 查询单个订单
  querysignorder (orderid) {
    return fetch(`/apppublic/order/getbyorderid/${orderid}`)
  },
  // 支付订单接口
  paymentorder (params) {
    return post('/apppublic/pay', params)
  },
  // 校验营销日历token
  checkToken (params) {
    return post(calendarBaseUrl + '/user/token', params)
  },
  // 获取营销日历token
  get_calendar_token () {
    return fetch(consoleBaseUrl + '/apppublic/marketing_calendar/gettoken')
  },
  // 获取登录获客平台管理端的token
  get_huoke_manager_token () {
    return fetch(consoleBaseUrl + '/apppublic/xcxnetcom_appmanager/gettoken')
  },
  // 获取事件推荐图片
  get_template_remind (id, pageSize) {
    return fetch(calendarBaseUrl + '/template/remind?id=' + id + '&psize=' + pageSize)
  },
  // 营销日历获取推荐事件
  get_event_remind () {
    return fetch(calendarBaseUrl + '/event/remind')
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js